'use client';
import { Header, Image, Spacer, Typo } from 'components/ui-kit';
import { aboutPageService } from 'modules/about/services';
import styles from './about-page-header.module.scss';

export const AboutPageHeader = (): JSX.Element => {
  const { src, srcSet, alt } = aboutPageService.getWelcomeImageMedia();

  return (
    <div className={styles.aboutPageHeader}>
      <div className={styles.aboutPageHeaderImageWrapper}>
        <Image srcSet={srcSet} src={src} alt={alt} />
      </div>
      <div className={styles.aboutPageHeaderDescription}>
        <Header level={2}>О нас</Header>
        <Spacer size={32} />
        <Typo variant="l">
          <p>
            Универмаг&nbsp;&mdash; магазин для предпринимателей от&nbsp;Точки.
          </p>

          <p>
            Мы&nbsp;создаём одежду и&nbsp;предметы, смысл которых&nbsp;&mdash;{' '}
            <b>вдохновлять предпринимать</b>. Побуждать к&nbsp;действию,
            помогать найти второе дыхание, громко заявить о&nbsp;себе или просто
            видеть в&nbsp;толпе своих.
          </p>

          <p>
            Каждая вещь из&nbsp;Универмага&nbsp;&mdash; символ дерзких
            и&nbsp;мечтательных. Тех, кто относится к&nbsp;делу с&nbsp;азартом
            и&nbsp;страстью, не&nbsp;пасует перед препятствиями
            и&nbsp;продолжает делать мир лучше. То&nbsp;есть символ
            предпринимателей&nbsp;&mdash; как их&nbsp;видит Точка.
          </p>

          <p>
            Поэтому важно всё: мы&nbsp;тщательно продумываем концепции,
            тестируем образцы и&nbsp;бережно относимся
            к&nbsp;смыслу&nbsp;&mdash; главным для нас остаётся не&nbsp;логотип,
            а&nbsp;качество и&nbsp;философия.
          </p>

          <p>
            Мы&nbsp;смотрим на&nbsp;предпринимательство с&nbsp;неожиданных
            сторон, поэтому часто создаём что-то вместе с&nbsp;другими брендами
            и&nbsp;персонами. Универмаг выбирает смелых, ярких и&nbsp;близких
            по&nbsp;духу, и&nbsp;каждый раз получается что-то особенное.
          </p>

          <p>
            Мы&nbsp;давно работаем над одеждой и&nbsp;предметами, которые служат
            напоминанием о&nbsp;важном, вдохновением и&nbsp;настоящим манифестом
            предпринимательства. Раньше их&nbsp;можно было получить только
            в&nbsp;подарок от&nbsp;Точки, а&nbsp;теперь можно купить: себе или
            другому мечтателю, создателю и&nbsp;предпринимателю.
          </p>
        </Typo>
      </div>
    </div>
  );
};
